module.exports = __webpack_public_path__ + "img/beian2.d0289dc0.png";